import React from "react";
import {renderRichText} from "gatsby-source-contentful/rich-text";

const CodeblockSection = ({content}) => {
const codeSnippet = `
<pre>
<span>const</span> <em>usdcAmt</em> = USDC(1_000);
<span>const</span> <em>tiaChain</em> = <span>E</span>(orchestration).getChain('celestia');
<span>const</span> <em>icaTia</em> = <span>await</span> <span>E</span>(tiaChain).createAccount();

<span>const</span> <em>hops</em> = hopOsmoSwap('TIA').hopSend(icaTia.getAddr());
<span>await</span> <span>E</span>(icaNoble).send(usdcAmt, hops);

<span>const</span> <em>tiaAmt</em> = <span>await</span> icaTia.getBalance('TIA');
<span>await</span> <span>E</span>(icaTia).delegate(tiaAmt, celestiaValidator);
</pre>`

    return (
        <section className="how-it-works">
            <div className="container">
                <div className="row d-flex align-items-center">
                    <div className="col-lg-4">
                        <h3>{content.title}</h3>
                        {renderRichText(content.body)}
                    </div>
                    <div className="col-lg-8">
                        <div className="row">
                            <div className="decorate-container">
                                <div className="decorate">
                                    <span className="decorate__item"/>
                                    <span className="decorate__item"/>
                                </div>
                            </div>
                            <div className="col-auto">
                            </div>
                            <div className="col code">
                                <code dangerouslySetInnerHTML={{__html:codeSnippet}}>

                                </code>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CodeblockSection;
